import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "./locales/en/common";
import enAboutPage from "./locales/en/aboutPage";
import enAccessRequestManager from "./locales/en/accessRequestManager";
import enApiErrors from "./locales/en/apiErrors";
import enAddMemberWidget from "./locales/en/addMemberWidget";
import enAdminDashboard from "./locales/en/adminDashboard";
import enAdminNotificationCenter from "./locales/en/adminNotificationCenter";
import enAdminRequestsSplitView from "./locales/en/adminRequestsSplitView";
import enApp from "./locales/en/app";
import enColumnValidationWarning from "./locales/en/columnValidationWarning";
import enCreateProjectDialog from "./locales/en/createProjectDialog";
import enCreateUserDialog from "./locales/en/createUserDialog";
import enCsvProcessor from "./locales/en/csvProcessor";
import enDataRequestForm from "./locales/en/dataRequestForm";
import enDatasetBrowser from "./locales/en/datasetBrowser";
import enDatasetDetailPanel from "./locales/en/datasetDetailPanel";
import enDataSourcePortal from "./locales/en/dataSourcePortal";
import enEditRequestDialog from "./locales/en/editRequestDialog";
import enEmailVerification from "./locales/en/emailVerification";
import enForgotPassword from "./locales/en/forgotPassword";
import enForwardRequestPanel from "./locales/en/forwardRequestPanel";
import enHomePage from "./locales/en/homePage";
import enImportWizard from "./locales/en/importWizard";
import enInvitationPreviewModal from "./locales/en/invitationPreviewModal";
import enInviteUploaderForm from "./locales/en/inviteUploaderForm";
import enInviteUserWidget from "./locales/en/inviteUserWidget";
import enLogin from "./locales/en/login";
import enMyAccessRequests from "./locales/en/myAccessRequests";
import enNotificationBell from "./locales/en/notificationBell";
import enNotificationDetailModal from "./locales/en/notificationDetailModal";
import enNotificationDropdown from "./locales/en/notificationDropdown";
import enNotificationItem from "./locales/en/notificationItem";
import enNotificationListPage from "./locales/en/notificationListPage";
import enPiiValueFindingsPanel from "./locales/en/piiValueFindingsPanel";
import enProfileSettings from "./locales/en/profileSettings";
import enProjectDatasetsSplitView from "./locales/en/projectDatasetsSplitView";
import enProjectPage from "./locales/en/projectPage";
import enProjectRequestsPanel from "./locales/en/projectRequestsPanel";
import enProjectSettings from "./locales/en/projectSettings";
import enPublicLayout from "./locales/en/publicLayout";
import enRegister from "./locales/en/register";
import enRequestComments from "./locales/en/requestComments";
import enResetPassword from "./locales/en/resetPassword";
import enRoadmapPage from "./locales/en/roadmapPage";
import enSecurityPage from "./locales/en/securityPage";
import enSecuritySummary from "./locales/en/securitySummary";
import enSelfUploadModal from "./locales/en/selfUploadModal";
import enSessionExpiredModal from "./locales/en/sessionExpiredModal";
import enSideNav from "./locales/en/sideNav";
import enTwoFactorSetup from "./locales/en/twoFactorSetup";
import enUnifiedConsole from "./locales/en/unifiedConsole";
import enUploadScopeSelector from "./locales/en/uploadScopeSelector";
import enUserMenu from "./locales/en/userMenu";
import enUserTable from "./locales/en/userTable";
import enYourRequestsPage from "./locales/en/yourRequestsPage";

import isCommon from "./locales/is/common";
import isAboutPage from "./locales/is/aboutPage";
import isAccessRequestManager from "./locales/is/accessRequestManager";
import isApiErrors from "./locales/is/apiErrors";
import isAddMemberWidget from "./locales/is/addMemberWidget";
import isAdminDashboard from "./locales/is/adminDashboard";
import isAdminNotificationCenter from "./locales/is/adminNotificationCenter";
import isAdminRequestsSplitView from "./locales/is/adminRequestsSplitView";
import isApp from "./locales/is/app";
import isColumnValidationWarning from "./locales/is/columnValidationWarning";
import isCreateProjectDialog from "./locales/is/createProjectDialog";
import isCreateUserDialog from "./locales/is/createUserDialog";
import isCsvProcessor from "./locales/is/csvProcessor";
import isDataRequestForm from "./locales/is/dataRequestForm";
import isDatasetBrowser from "./locales/is/datasetBrowser";
import isDatasetDetailPanel from "./locales/is/datasetDetailPanel";
import isDataSourcePortal from "./locales/is/dataSourcePortal";
import isEditRequestDialog from "./locales/is/editRequestDialog";
import isEmailVerification from "./locales/is/emailVerification";
import isForgotPassword from "./locales/is/forgotPassword";
import isForwardRequestPanel from "./locales/is/forwardRequestPanel";
import isHomePage from "./locales/is/homePage";
import isImportWizard from "./locales/is/importWizard";
import isInvitationPreviewModal from "./locales/is/invitationPreviewModal";
import isInviteUploaderForm from "./locales/is/inviteUploaderForm";
import isInviteUserWidget from "./locales/is/inviteUserWidget";
import isLogin from "./locales/is/login";
import isMyAccessRequests from "./locales/is/myAccessRequests";
import isNotificationBell from "./locales/is/notificationBell";
import isNotificationDetailModal from "./locales/is/notificationDetailModal";
import isNotificationDropdown from "./locales/is/notificationDropdown";
import isNotificationItem from "./locales/is/notificationItem";
import isNotificationListPage from "./locales/is/notificationListPage";
import isPiiValueFindingsPanel from "./locales/is/piiValueFindingsPanel";
import isProfileSettings from "./locales/is/profileSettings";
import isProjectDatasetsSplitView from "./locales/is/projectDatasetsSplitView";
import isProjectPage from "./locales/is/projectPage";
import isProjectRequestsPanel from "./locales/is/projectRequestsPanel";
import isProjectSettings from "./locales/is/projectSettings";
import isPublicLayout from "./locales/is/publicLayout";
import isRegister from "./locales/is/register";
import isRequestComments from "./locales/is/requestComments";
import isResetPassword from "./locales/is/resetPassword";
import isRoadmapPage from "./locales/is/roadmapPage";
import isSecuritySummary from "./locales/is/securitySummary";
import isSelfUploadModal from "./locales/is/selfUploadModal";
import isSessionExpiredModal from "./locales/is/sessionExpiredModal";
import isSideNav from "./locales/is/sideNav";
import isTwoFactorSetup from "./locales/is/twoFactorSetup";
import isUnifiedConsole from "./locales/is/unifiedConsole";
import isUploadScopeSelector from "./locales/is/uploadScopeSelector";
import isUserMenu from "./locales/is/userMenu";
import isUserTable from "./locales/is/userTable";
import isYourRequestsPage from "./locales/is/yourRequestsPage";

export const SUPPORTED_LANGUAGES = ["en", "is"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const LANGUAGE_STORAGE_KEY = "pseudonymizer.language";

const resources = {
  en: {
    common: enCommon,
    aboutPage: enAboutPage,
    accessRequestManager: enAccessRequestManager,
    apiErrors: enApiErrors,
    addMemberWidget: enAddMemberWidget,
    adminDashboard: enAdminDashboard,
    adminNotificationCenter: enAdminNotificationCenter,
    adminRequestsSplitView: enAdminRequestsSplitView,
    app: enApp,
    columnValidationWarning: enColumnValidationWarning,
    createProjectDialog: enCreateProjectDialog,
    createUserDialog: enCreateUserDialog,
    csvProcessor: enCsvProcessor,
    dataRequestForm: enDataRequestForm,
    datasetBrowser: enDatasetBrowser,
    datasetDetailPanel: enDatasetDetailPanel,
    dataSourcePortal: enDataSourcePortal,
    editRequestDialog: enEditRequestDialog,
    emailVerification: enEmailVerification,
    forgotPassword: enForgotPassword,
    forwardRequestPanel: enForwardRequestPanel,
    homePage: enHomePage,
    importWizard: enImportWizard,
    invitationPreviewModal: enInvitationPreviewModal,
    inviteUploaderForm: enInviteUploaderForm,
    inviteUserWidget: enInviteUserWidget,
    login: enLogin,
    myAccessRequests: enMyAccessRequests,
    notificationBell: enNotificationBell,
    notificationDetailModal: enNotificationDetailModal,
    notificationDropdown: enNotificationDropdown,
    notificationItem: enNotificationItem,
    notificationListPage: enNotificationListPage,
    piiValueFindingsPanel: enPiiValueFindingsPanel,
    profileSettings: enProfileSettings,
    projectDatasetsSplitView: enProjectDatasetsSplitView,
    projectPage: enProjectPage,
    projectRequestsPanel: enProjectRequestsPanel,
    projectSettings: enProjectSettings,
    publicLayout: enPublicLayout,
    register: enRegister,
    requestComments: enRequestComments,
    resetPassword: enResetPassword,
    roadmapPage: enRoadmapPage,
    securityPage: enSecurityPage, // English only, see SecurityTechnicalPage
    securitySummary: enSecuritySummary,
    selfUploadModal: enSelfUploadModal,
    sessionExpiredModal: enSessionExpiredModal,
    sideNav: enSideNav,
    twoFactorSetup: enTwoFactorSetup,
    unifiedConsole: enUnifiedConsole,
    uploadScopeSelector: enUploadScopeSelector,
    userMenu: enUserMenu,
    userTable: enUserTable,
    yourRequestsPage: enYourRequestsPage,
  },
  is: {
    common: isCommon,
    aboutPage: isAboutPage,
    accessRequestManager: isAccessRequestManager,
    apiErrors: isApiErrors,
    addMemberWidget: isAddMemberWidget,
    adminDashboard: isAdminDashboard,
    adminNotificationCenter: isAdminNotificationCenter,
    adminRequestsSplitView: isAdminRequestsSplitView,
    app: isApp,
    columnValidationWarning: isColumnValidationWarning,
    createProjectDialog: isCreateProjectDialog,
    createUserDialog: isCreateUserDialog,
    csvProcessor: isCsvProcessor,
    dataRequestForm: isDataRequestForm,
    datasetBrowser: isDatasetBrowser,
    datasetDetailPanel: isDatasetDetailPanel,
    dataSourcePortal: isDataSourcePortal,
    editRequestDialog: isEditRequestDialog,
    emailVerification: isEmailVerification,
    forgotPassword: isForgotPassword,
    forwardRequestPanel: isForwardRequestPanel,
    homePage: isHomePage,
    importWizard: isImportWizard,
    invitationPreviewModal: isInvitationPreviewModal,
    inviteUploaderForm: isInviteUploaderForm,
    inviteUserWidget: isInviteUserWidget,
    login: isLogin,
    myAccessRequests: isMyAccessRequests,
    notificationBell: isNotificationBell,
    notificationDetailModal: isNotificationDetailModal,
    notificationDropdown: isNotificationDropdown,
    notificationItem: isNotificationItem,
    notificationListPage: isNotificationListPage,
    piiValueFindingsPanel: isPiiValueFindingsPanel,
    profileSettings: isProfileSettings,
    projectDatasetsSplitView: isProjectDatasetsSplitView,
    projectPage: isProjectPage,
    projectRequestsPanel: isProjectRequestsPanel,
    projectSettings: isProjectSettings,
    publicLayout: isPublicLayout,
    register: isRegister,
    requestComments: isRequestComments,
    resetPassword: isResetPassword,
    roadmapPage: isRoadmapPage,
    securitySummary: isSecuritySummary,
    selfUploadModal: isSelfUploadModal,
    sessionExpiredModal: isSessionExpiredModal,
    sideNav: isSideNav,
    twoFactorSetup: isTwoFactorSetup,
    unifiedConsole: isUnifiedConsole,
    uploadScopeSelector: isUploadScopeSelector,
    userMenu: isUserMenu,
    userTable: isUserTable,
    yourRequestsPage: isYourRequestsPage,
  },
};

function detectInitialLanguage(): SupportedLanguage {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored && (SUPPORTED_LANGUAGES as readonly string[]).includes(stored)) {
      return stored as SupportedLanguage;
    }
  } catch {
    // localStorage unavailable (e.g. private browsing) — fall through to browser language.
  }
  const browserLang = window.navigator.language?.slice(0, 2);
  return browserLang === "is" ? "is" : "en";
}

// Keep <html lang> in step with the UI language, so screen readers, spell-check and
// hyphenation treat the page as Icelandic or English. public/index.html ships "en".
function syncDocumentLang(lang: string): void {
  document.documentElement.lang = lang;
}

const initialLanguage = detectInitialLanguage();
syncDocumentLang(initialLanguage);
i18n.on("languageChanged", syncDocumentLang);

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: "en",
  defaultNS: "common",
  ns: Object.keys(resources.en),
  interpolation: {
    escapeValue: false, // React already escapes rendered output.
  },
  returnNull: false,
});

export function changeLanguage(lang: SupportedLanguage): void {
  i18n.changeLanguage(lang);
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch {
    // Best-effort persistence only.
  }
}

export default i18n;
